import { useCallback, useState } from "react";
export const useWizardStep = (initialCount, numberOfSteps) => {
    const [currentStep, setCurrentStep] = useState(initialCount);
    const onStepChange = useCallback((selectedStepNumber) => {
        if (selectedStepNumber >= numberOfSteps || selectedStepNumber < 0) {
            return;
        }
        setCurrentStep(selectedStepNumber);
    }, [numberOfSteps]);
    const toStep = useCallback((step) => onStepChange(step), [onStepChange]);
    const toNextStep = useCallback(() => onStepChange(currentStep + 1), [currentStep, onStepChange]);
    const toPreviousStep = useCallback(() => onStepChange(currentStep - 1), [currentStep, onStepChange]);
    return {
        currentStep,
        toNextStep,
        toPreviousStep,
        toStep,
    };
};
